import { BaseClient } from '../client';
import { shopkeeperMock } from './shopkeeper.mocks';
import { TRevenda } from './shopkeeper.types';

export const getAllShopkeepers = async () => {
	if (process.env.NODE_ENV === 'development') {
		return shopkeeperMock;
	}

	try {
		const response = await BaseClient.get<TRevenda[]>(`/Revendas`).then(
			(response) => response.data
		);

		return response;
	} catch (error) {
		console.error(error);
	}
};
